import slice from 'lodash/slice';
import concat from 'lodash/concat';
import includes from 'lodash/includes';

import {
  ADVANCED_LINK_EDITOR_PLUGIN
} from 'zoomforth_codesbane_editor/component_lib/froala_plugins/advanced_link_editor.plugin.jsx';

import {
  TRANSLATE_TEXT_PLUGIN
} from 'zoomforth_codesbane_editor/component_lib/froala_plugins/translation.plugin.jsx';


export const DEFAULT_FROALA_TOOLBAR_BUTTONS = {
  'moreParagraph': {
    'buttons': [
      'paragraphFormat',
      'quote',
      'alignLeft',
      'alignCenter',
      'alignRight',
      'alignJustify',
      'formatOL',
      'formatUL',
      'outdent',
      'indent'
    ],
    'buttonsVisible': 1
  },
  'moreText': {
    'buttons': [
      'bold',
      'italic',
      'underline',
      'strikeThrough',
      'subscript',
      'superscript',
      'clearFormatting'
    ],
    'buttonsVisible': 3
  },
  'moreRich': {
    'buttons': [
      'insertLink',
      'insertTable',
      'textColor',
      'backgroundColor',
      'fontAwesome',
      'insertHR'
    ],
    'buttonsVisible': 1
  },
  'moreMisc': {
    'buttons': [
      'undo',
      'redo',
      'html',
      'selectAll',
      'help'
    ],
    'buttonsVisible': 3
  }
};

export const BASIC_FROALA_TOOLBAR_BUTTONS = {
  'moreParagraph': {
    'buttons': [
      'paragraphFormat',
      'alignLeft',
      'alignCenter',
      'alignRight',
      'alignJustify',
      'formatOL',
      'formatUL',
      'outdent',
      'indent'
    ],
    'buttonsVisible': 1
  },
  'moreText': {
    'buttons': [
      'bold',
      'italic',
      'underline',
      'strikeThrough',
      'subscript',
      'superscript',
      'clearFormatting'
    ],
    'buttonsVisible': 3
  },
  'moreRich': {
    'buttons': [
      'insertLink'
    ],
    'buttonsVisible': 2
  },
  'moreMisc': {
    'buttons': [
      'undo',
      'redo',
      'selectAll',
      'html',
      'help'
    ],
    'buttonsVisible': 2
  }
};

export const getFroalaLinkEditorEnabledButtons = (shouldShowTranslationPlugin)=> {
  const allButtons = DEFAULT_FROALA_TOOLBAR_BUTTONS;

  allButtons['moreRich']['buttons'][0] = ADVANCED_LINK_EDITOR_PLUGIN;

  if (shouldShowTranslationPlugin) {
    const btns = allButtons['moreMisc']['buttons'];

    if (!includes(btns, TRANSLATE_TEXT_PLUGIN)) {
      allButtons['moreMisc']['buttons'] = concat(
        slice(btns, 0, 2),
        [TRANSLATE_TEXT_PLUGIN],
        slice(btns, 2),
      );
    }
  }

  return allButtons;
};
